<template>
  <div class="noData">
      <div :style="'font-size:'+fontSize+'px'"><i class="glyphicon glyphicon glyphicon-info-sign"></i>{{text}}</div>
  </div>
</template>

<script>
  export default {
    props: {
        text: {},
        fontSize: {}
    }
  }
</script>

<style lang="scss" type="text/scss">
.noData {
    text-align: center;
    padding: 30px 0;
    .glyphicon{
        padding-right: 7px;
    }
}
</style>





// WEBPACK FOOTER //
// noData.vue?654659a2